import { searchArrayOfObjects } from '@aibees/shared/utils';
import { SeeAllPopupItems } from '../types';

export function useSeeAllPopupSearchResult(
  items: SeeAllPopupItems[],
  search: string
) {
  return searchArrayOfObjects<SeeAllPopupItems>(items, 'text', search);
}
